export const CHANGE_PAGE = "CHANGE_PAGE"
export const SAVE_PAGE = "SAVE_PAGE"
export const CATEGORY_PAGE = "CATEGORY_PAGE"